import { Link } from 'react-router-dom';
import { NOT_CONFIGURED } from '../lib/emailSettings';

/**
 * MERCH-107 (D117): shown under "Email not sent" when the reason is that the store
 * has no email server yet; points to Settings → Email (the tab is owner only, so the
 * text says who can set it up). Renders nothing for any other reason.
 */
export default function MailNotConfiguredHint({ reason }) {
  if (reason !== NOT_CONFIGURED) return null;
  return (
    <p className="text-xs">
      Your store has no email server set up yet. The store owner can add one in{' '}
      <Link to="/settings?tab=email" className="underline font-semibold">Settings → Email</Link>.
    </p>
  );
}
